import React, { useEffect, useMemo } from "react";
import { useTheme } from "../../DataStore/ThemeContext";
import { useSchool } from "../../DataStore/SchoolContext";
import { useNavigate } from "react-router-dom";

const PageTitle = ({
  title,
  description,
  sticky = false,
  iconClass = null,
  badgeElement = null,
}) => {
  const { openSettings, currentNotify } = useTheme();
  const { getCurrentBatch, currentBatch } = useSchool();
  const navigate = useNavigate();

  useEffect(() => {
    getCurrentBatch();
  }, []);

  const batchName = useMemo(
    () => currentBatch?.batch_name || "Click to setup",
    [currentBatch]
  );

  const handleBatch = () => {
    // openSettings("Billing Batch", "BillingBatch");
    navigate("/school-fees-batch");
  };

  return (
    <>
      <style>{`
        .yx-page-title-wrap{
          border-radius: 18px;
          border: 1px solid rgba(15,23,42,.06);
          background: #fff;
          box-shadow: 0 1px 2px rgba(16,24,40,.04);
          overflow: hidden;
        }

        .yx-page-title-head{
          padding: 18px 20px;
          background: linear-gradient(180deg, rgba(79,70,229,.06), rgba(255,255,255,0));
          border-bottom: 1px solid rgba(15,23,42,.06);
        }

       

       .yx-page-title-sticky{
        position: sticky;
        top: 52px;              /* adjust if you have a fixed top navbar */
        z-index: 100;
        background: transparent;
        padding-bottom: 12px;
        }

        /* Optional: add spacing so content doesn't jump under it */
        .yx-page-title-sticky .yx-page-title-wrap{
        box-shadow: 0 8px 18px rgba(16,24,40,.06);
        }


        .yx-title-left{
          display:flex;
          align-items:center;
          gap: 14px;
          min-width: 0;
        }

        .yx-title-ic{
          width: 52px;
          height: 52px;
          border-radius: 16px;
          display:flex;
          align-items:center;
          justify-content:center;
          background: #4F46E5;
          color: #fff;
          box-shadow: 0 10px 22px rgba(79,70,229,.18);
          flex: 0 0 auto;
        }

        .yx-title-ic i{
          font-size: 22px;
          opacity: .95;
        }

        .yx-title-text{
          min-width: 0;
        }

        .yx-title-h{
          margin: 0;
          font-weight: 900;
          font-size: 20px;
          color: #0F172A;
          letter-spacing: .2px;
          display:flex;
          align-items:center;
          gap: 10px;
          flex-wrap: wrap;
        }

        .yx-title-sub{
          margin-top: 4px;
          color: rgba(71,85,105,.9);
          font-size: 13px;
          line-height: 1.35;
        }

        .yx-title-right{
          display:flex;
          align-items:center;
          gap: 10px;
          justify-content:flex-end;
        }

        .yx-batch-pill{
          display:inline-flex;
          align-items:center;
          gap: 10px;
          padding: 10px 12px;
          border-radius: 14px;
          border: 1px solid rgba(79,70,229,.14);
          background: rgba(79,70,229,.06);
          color: rgba(15,23,42,.85);
          font-weight: 800;
          font-size: 13px;
          white-space: nowrap;
        }

        .yx-batch-pill .yx-batch-label{
          color: rgba(71,85,105,.85);
          font-weight: 800;
        }

        .yx-batch-pill .yx-batch-value{
          color: #4F46E5;
          cursor: pointer;
        }

        .yx-batch-pill .yx-batch-value:hover{
          text-decoration: underline;
        }

        .yx-batch-ic{
          width: 34px;
          height: 34px;
          border-radius: 12px;
          display:flex;
          align-items:center;
          justify-content:center;
          background: rgba(79,70,229,.10);
          color: #4F46E5;
          flex: 0 0 auto;
        }

        @media (max-width: 768px){
          .yx-page-title-head{ padding: 16px; }
          .yx-title-ic{ width: 46px; height: 46px; border-radius: 14px; }
          .yx-title-h{ font-size: 18px; }
          .yx-title-right{ margin-top: 12px; justify-content:flex-start; width: 100%; }
        }
      `}</style>

      <div className={`${sticky ? "yx-page-title-sticky" : ""}`}>
        <div className="yx-page-title-wrap">
          <div className="yx-page-title-head">
            <div className="d-flex align-items-start justify-content-between flex-wrap">
              {/* Left */}
              <div className="yx-title-left">
                {iconClass && (
                  <div className="yx-title-ic">
                    <i className={iconClass} />
                  </div>
                )}

                <div className="yx-title-text">
                  <h2 className="yx-title-h">
                    {title}
                    {badgeElement}
                  </h2>
                  {description ? <div className="yx-title-sub">{description}</div> : null}
                </div>
              </div>

              {/* Right */}
              <div className="yx-title-right d-none d-md-flex">
                <div className="yx-batch-pill">
                  <span className="yx-batch-ic">
                    <i className="fa fa-calendar-alt" />
                  </span>

                  <span className="yx-batch-label">Batch:</span>

                  <span className="yx-batch-value" onClick={handleBatch} title="Change batch">
                    {batchName}
                  </span>
                </div>
              </div>

              {/* Mobile right */}
              <div className="yx-title-right d-flex d-md-none">
                <div className="yx-batch-pill w-100 justify-content-between" onClick={handleBatch}>
                  <span className="d-flex align-items-center" style={{ gap: 10 }}>
                    <span className="yx-batch-ic">
                      <i className="fa fa-calendar-alt" />
                    </span>
                    <span className="yx-batch-label">Batch</span>
                  </span>
                  <span className="yx-batch-value">{batchName}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {currentNotify}
    </>
  );
};

export default PageTitle;
